import { render, staticRenderFns } from "./InvoiceModal.vue?vue&type=template&id=35bc780e&scoped=true"
import script from "./InvoiceModal.vue?vue&type=script&lang=js"
export * from "./InvoiceModal.vue?vue&type=script&lang=js"
import style0 from "./InvoiceModal.vue?vue&type=style&index=0&id=35bc780e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bc780e",
  null
  
)

export default component.exports